import { AdminDashboardDataFilterV2, AdminDashboardNewUserStaticsResponse } from '../../graphql/API';
import { adminGetDashboardNewUsersData } from '../../graphql/queries';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

// The re-application counts aren't in the generated type yet (pre-codegen). They cover
// the review cycles opened in the selected period, split by where the model stands
// today: still under review, let back in (Active > Re-applied) or waitlisted
// (Waitlist > Re-applied). `totalReapplications` is the sum of the three.
export type AdminDashboardNewUserStaticsResponseExt = AdminDashboardNewUserStaticsResponse & {
  totalReapplications: number;
  totalInReviewReapplications: number;
  totalAcceptedReapplications: number;
  totalRejectedReapplications: number;
};

export const adminGetDashboardNewUsersDataApi = async (
  filter: AdminDashboardDataFilterV2,
): Promise<AdminDashboardNewUserStaticsResponseExt> => {
  const result = await executeGql(adminGetDashboardNewUsersData, { filter });
  return processGqlResult<AdminDashboardNewUserStaticsResponseExt>(
    'adminGetDashboardNewUsersData',
    result,
  );
};
